<template>
  <v-row class="py-1 px-5 grey lighten-4 fill-height">
    <v-col cols="12">
      <v-row>
        <v-col cols="12" SearchC>
          <Search 
            :loading="loading"
            :resourceSettings="resourceSettings" 
            @searchResource="searchResource" 
            @create="dialog = true"
          />
        </v-col>
        <v-col cols="12" Headers>
          <v-card class="px-3" :loading="loading">
            <v-card-text>
              <v-row class="pa-0">
                <v-col cols="2" :class="`${arabic?'arFont':'enFont'} pa-0 font-weight-bold`">
                  {{i18n.name}}
                </v-col>
                <v-col cols="2" :class="`${arabic?'arFont':'enFont'} pa-0 font-weight-bold text-left`">
                  {{i18n.agent}}
                </v-col>
                <v-col cols="1" :class="`${arabic?'arFont':'enFont'} pa-0 font-weight-bold text-center`">
                  {{i18n.sent}}
                </v-col>
                <v-col cols="1" :class="`${arabic?'arFont':'enFont'} pa-0 font-weight-bold text-center`">
                  {{i18n.opened}}
                </v-col>
                <v-col cols="1" :class="`${arabic?'arFont':'enFont'} pa-0 font-weight-bold text-center`">
                  {{i18n.clicked}}
                </v-col>
                <v-col cols="1" :class="`${arabic?'arFont':'enFont'} pa-0 font-weight-bold text-center`">
                  {{i18n.status}}
                </v-col>
                <v-col cols="3" :class="`${arabic?'arFont':'enFont'} pa-0 font-weight-bold text-center`">
                  {{i18n.viewIconTooltip}}
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" PagingC>
          <Paging 
            :resourceSettings="resourceSettings" 
            :resource="resource"
            @loadResource="loadResource"
            @pageByNumber="pageByNumber"
          />
        </v-col>
        <v-col cols="12" Details>
          <v-card class="px-3" :loading="loading">
            <v-card-text>
              <v-row class="pa-0 mb-2 elevation-2 px-2 align-center py-3" 
                v-for="(r, i) in resource.data" :key="'resource-'+i"  style="cursor:pointer;">
                <v-col cols="6" md="2" :class="`${arabic?'arFont':'enFont'} pa-0 font-weight-bold`">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">{{r.company.toUpperCase()}}</span>
                    </template>
                    <div class="text-center">
                      <div :class="`${arabic?'arFont':'enFont'}`">{{r.company}}</div>
                      <div :class="`${arabic?'arFont':'enFont'}`">{{r.program}}</div>
                    </div>
                  </v-tooltip>
                </v-col>
                <v-col cols="6" md="2" :class="`${arabic?'arFont':'enFont'} pa-0 font-weight-bold`">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">{{r.program.toUpperCase()}}</span>
                    </template>
                    <div class="text-center">
                      <div :class="`${arabic?'arFont':'enFont'}`">{{r.company}}</div>
                      <div :class="`${arabic?'arFont':'enFont'}`">{{r.program}}</div>
                    </div>
                  </v-tooltip>
                </v-col>
                <v-col cols="6" md="3" :class="`${arabic?'arFont':'enFont'} pa-0`">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">{{r.email}}</span>
                    </template>
                    <div :class="`${arabic?'arFont':'enFont'} pa-0`">{{r.updated_at}}</div>
                  </v-tooltip>
                </v-col>
                <v-col cols="6" md="1" :class="`${arabic?'arFont':'enFont'} pa-0 adminSwitch text-center`">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        {{r.opens}}
                        <span style="font-size:8px;">({{r.open_percentage}}%)</span>
                      </span>
                    </template>
                    <div :class="`${arabic?'arFont':'enFont'} pa-0`">{{r.opens}} ({{r.open_percentage}}%) {{i18n.opened}}</div>
                  </v-tooltip>
                </v-col>
                <v-col cols="6" md="1" :class="`${arabic?'arFont':'enFont'} pa-0 adminSwitch text-center`">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        {{r.clicks}}
                        <span style="font-size:8px;">({{r.click_percentage}}%)</span>
                      </span>
                    </template>
                    <div :class="`${arabic?'arFont':'enFont'} pa-0`">{{r.clicks}} ({{r.click_percentage}}%) {{i18n.clicked}}</div>
                  </v-tooltip>
                </v-col>
                <v-col cols="6" md="1" :class="`${arabic?'arFont':'enFont'} pa-0 adminSwitch text-center`">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" color="primary" 
                        :disabled="r.sent || r.active_sending"
                        icon x-small @click.stop="()=>{
                        dialog = true
                        editing = true
                        newResource = r
                      }">
                        <v-icon>create</v-icon>
                      </v-btn>
                    </template>
                    <span :class="`${arabic?'arFont':'enFont'} pa-0`">
                      {{i18n.editIconTooltip}}
                    </span>
                  </v-tooltip>
                </v-col>
                <v-col cols="6" md="1" :class="`${arabic?'arFont':'enFont'} pa-0 adminSwitch text-center`">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" color="error" 
                        :disabled="r.sent || r.active_sending"
                        icon x-small @click.stop="()=>{
                        dialog = true
                        deleting = true
                        newResource = r
                      }">
                          <v-icon>delete</v-icon>
                      </v-btn>
                    </template>
                    <span :class="`${arabic?'arFont':''} pa-0`">
                      {{i18n.deleteIconTooltip}}
                    </span>
                  </v-tooltip>
                </v-col>
                <v-col cols="6" md="1" :class="`${arabic?'arFont':'enFont'} pa-0 adminSwitch text-center`">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" color="primary" 
                        :disabled="r.sent || r.active_sending"
                        icon x-small @click.stop="sendCampaign(r)">
                          <v-icon>settings</v-icon>
                      </v-btn>
                    </template>
                    <span :class="`${arabic?'arFont':''} pa-0`">
                      {{i18n.scheduleIconTooltip}}
                    </span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" NewEditDeleteDialog>
          <v-dialog v-model="dialog" persistent max-width="1000">
            <v-card :loading="loading">
              <v-card-title :class="`${arabic?'arFont':'enFont'} font-weight-bold`" style="font-size:22px;">
                <div>{{ i18n[resourceSettings.resourceName]  + ' | ' }}<span class="font-weight-light">{{i18n.add}}</span></div>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="4" class="py-0" v-for="(field, k) in resourceKeys" :key="'key-' + k">
                    <v-text-field
                      :label="i18n[field.label]"
                      :name="i18n[field.label]"
                      outlined
                      v-if="field.type == 'text'"
                      :rules="[field.required ? rules.required : false, field.email ? rules.email : false]"
                      dense
                      :class="`${arabic?'arFont':'enFont'}`"
                      v-model="newResource[field.name]"
                    ></v-text-field>
                    <v-autocomplete
                      :items="getItems(field.items)"
                      v-model="newResource[field.name]"
                      :label="i18n[field.label]"
                      :name="i18n[field.label]"
                      :rules="[ field.required ? rules.required : false]"
                      v-if="field.type == 'select'"
                      outlined
                      dense
                      item-text="name"
                      item-value="id"
                      :class="`${arabic?'arFont':'enFont'}`"

                    >
                      <!-- <template v-slot:selection="{ attr, on, item, selected }">
                        <span
                          v-bind="attr"
                          :input-value="selected"
                          v-on="on"
                          :class="`${arabic?'arFont':'enFont'}`"
                        >
                          {{i18n[item]}}
                        </span>
                      </template>
                      <template v-slot:item="{ item }">
                        <span
                          :class="`${arabic?'arFont':'enFont'}`"
                        >
                          {{i18n[item]}}
                        </span>
                      </template> -->
                    </v-autocomplete>
                    <v-switch 
                      v-if="field.type == 'switch'"
                      :class="`${arabic?'arFont':'enFont'}`" 
                      :label="i18n[field.label]" 
                      :name="i18n[field.label]" 
                      v-model="newResource[field.name]"
                    ></v-switch>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" text @click.native="dialog = false" :class="`${arabic?'arFont':'enFont'}`">{{i18n.cancelBtn}}</v-btn>
                <v-btn 
                  color="success" 
                  v-if="!newResource.id"
                  :disabled="!validate(newResource)"
                  text @click.native="postResource(newResource)" 
                  :class="`${arabic?'arFont':'enFont'}`"
                >{{i18n.submitBtn}}</v-btn>
                <v-btn 
                    color="success" 
                    v-if="newResource.id"
                    :disabled="!validate(newResource)"
                    text @click.native="updateResource(newResource)" 
                    :class="`${arabic?'arFont':'enFont'}`"
                  >{{i18n.updateBtn}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import Search from '@/components/Search'
import Paging from '@/components/Paging'
import { getRandomInt, randomString, getCDate, check, sleep } from '@/customFunction';
import { format, render, cancel, register } from 'timeago.js';
import axios from 'axios';
const headers = {'Accept': 'application/json'};

export default {
  components: { Search, Paging },
  data() {
    return {
      loading:false,
      dialog:false,
      vresource:[],
      resource:[],
      search:null,
      rules: {
        required: value => !!value || this.i18n['required'],
        email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n['valid_email']
      },
      resourceKeys:[
        {name: 'company', label:'company', type:'text', required:true },
        {name: 'program', label:'program', type:'text', required:true },
        {name: 'email', label:'email', type:'text', required:true },
      ],
      resourceSettings:{
        resourceName:null,
        search:true,
        create:true,
        pagination:true,
      },
      newResource:{},
      editing:false,
      deleting:false,
      templates:[],
      lists:[],
    }
  },
  
  methods: {
    validate(newResource, notify) {
      let fsr = this.resourceKeys.filter(x=>x.required)
      let fse = this.resourceKeys.filter(x=>x.email)
      let v = true
      fsr.forEach(x=>{
        if(!newResource[x.name]) {
          v = false
          if(notify)
          this.$emit('snackbarNotification', `${this.i18n[x.name]} ${this.i18n.required}`, 'error')
        }
      })
      fse.forEach(x=>{
        if(!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(newResource[x.name])) {
          v = false
          if(notify)
          this.$emit('snackbarNotification', `${this.i18n[x.name]} ${this.i18n.valid_email}`, 'error')
        }
      })
      return v
    },
    getItems(items) {
      return this[items]
    },
    superA(){
      return this.$store.state.user && this.$store.state.user.role == 'superadmin'
    },
    getFormat(d){
      return format(d)
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode != 46 && charCode != 45 && charCode != 46 &&
      !(charCode >= 48 && charCode <= 57)) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    goTo(path) {
      this.$router.push(path).catch(x=>{})
    },
    async loadResource() {
      return new Promise(async (res, rej)=>{
        this.loading = true
        if(!this.search){
          this.resource = await this.$store.dispatch('getResource', {resource:this.$route.path})
        } else {
          this.resource = await this.$store.dispatch('searchResource', {resource:this.$route.path + '/search', value:this.search})
        }
        this.loading = false
      })
    },
    async pageByNumber(n){
      return new Promise(async (res, rej)=>{
        this.loading = true
        if(!this.search){
          this.resource = await this.$store.dispatch('getResource', {resource:this.$route.path, page:`?page=${n}`})
        } else {
          this.resource = await this.$store.dispatch('searchResource', {resource:this.$route.path + `/search?page=${n}`, value:this.search})
        }
        this.loading = false
      })
    },
    async searchResource(search){
      return new Promise(async (res, rej)=>{
        this.search = search
        this.loading = true
        this.resource = await this.$store.dispatch('searchResource', {resource:this.$route.path + '/search', value:this.search})
        this.loading = false
      })
    },
    async updateResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        await this.$store.dispatch('putResource', {resource:this.$route.path + `/${r.id}`, value:r})
        this.dialog = false
        this.editing = false
        this.loading = false
        await this.loadResource()
        this.newResource = {}
      })
    },
    async deleteResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        await this.$store.dispatch('deleteResource', {resource:this.$route.path + `/${r.id}`})
        this.dialog = false
        this.deleting = false
        this.loading = false
        await this.loadResource()
        this.newResource = {}
      })
    },
    async postResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        console.log(JSON.stringify(r))
        await this.$store.dispatch('postResource', {resource:this.$route.path + `${r.id ? '/' + r.id : ''}`, value:r})
        this.dialog = false
        this.loading = false
        await this.loadResource()
        this.newResource = {}
      })
    },
    setResourceName(){
      this.resourceSettings.resourceName = this.$route.path.replace('/', '')
    }
  },
  watch:{
  },
  computed:{
    api(){
      return this.$store.state.settings.apiBase
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
  },
  async created(){
    this.setResourceName()
    await this.loadResource()
  },
  
}
</script>

<style>
.adminSwitch .v-input {
  margin-top:0 !important;
}
.adminSwitch .v-input__control {
  margin-bottom:0 !important;
}
.adminSwitch .v-label {
  font-size: 12px !important;
}
</style>